import { useClientSidebar as useSidebar } from "units/client/context/ClientSidebarProvider";
import { useTranslation } from "react-i18next";
import { Menu } from "lucide-react";

const MobileSidebarToggle = () => {
  const { toggleSidebar, isMobile, isSidebarOpen } = useSidebar();
  const { t } = useTranslation(["client"]);

  if (!isMobile || isSidebarOpen) return null;

  return (
    <button
      type="button"
      onClick={toggleSidebar}
      aria-label={t("sidebar.openSidebar")}
      dir="ltr"
      className="
        mobile-sidebar-toggle
        group
        fixed top-3
        w-10 h-10 flex items-center justify-center
        rounded-xl

        bg-teal-500/90 dark:bg-teal-600/80
        backdrop-blur-xl
        text-white

        shadow-lg shadow-teal-500/40
        border border-white/20 dark:border-teal-400/30

        transition-all duration-200
        hover:bg-teal-500 hover:shadow-xl hover:shadow-teal-500/60
        hover:scale-105
        active:scale-95
      "
      style={{
        // موقعیت فیزیکی ثابت — کاملاً مستقل از dir صفحه، هیچ کلاس/قانون RTL دیگه‌ای نمی‌تونه جابه‌جاش کنه
        right: "0.75rem",
        left: "auto",
        zIndex: 200, // بالاتر از سایدبار (z-40/50) و backdrop
      }}
    >
      <Menu className="w-5 h-5 group-hover:rotate-90 transition-transform duration-300" />
    </button>
  );
};

export default MobileSidebarToggle;